//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
SPLM.Drawings.ViewLabelTypes = Object.freeze({
    "Name" : "Name", "Letter" : "Letter"});

SPLM.Drawings.LabelPositionTypes = Object.freeze({
    "Above" : "Above", "Below" : "Below"});

SPLM.Drawings.LetterFormatTypes = Object.freeze({
    "A" : "A", "AA" : "AA", "AA1" : "AA1"});

SPLM.Drawings.RotationSymbolTypes = Object.freeze({
    "None" : "None", "Full" : "Full", "Right" : "Right", "Left" : "Left"});

SPLM.Drawings.ReferenceShowTypes = Object.freeze({
    "SheetandZone" : "SheetandZone", "Sheet" : "Sheet", "Zone" : "Zone"});

SPLM.Drawings.ScalePositionTypes = Object.freeze({
    "Above" : "Above", "Below" : "Below", "Before" : "Before", "After" : "After"});

SPLM.Drawings.ScaleValueFormatTypes = Object.freeze({
    "Ratio" : "Ratio", "CommonFraction" : "CommonFraction", "SingleLineFraction" : "SingleLineFraction", "Nx" : "Nx"});

export default SPLM;